import gql from 'graphql-tag';
export default gql`
subscription tableOrderUpdated( $id: String!){
    tableOrderUpdated(id: $id){
      id
      orderId
      parentOrderRef
      countryCode
      custId
      customerSegment
      rewardPoints
      rewardAmt
      counterId
      tokenId
      siteId
      name
      mobile
      email
      date
      orderFrom
      subOrderFrom
      timestamp
      updatedAt
      grandTotal
      tableNo
      blockedTables
      tableOrderStatus
      primaryWaiter
      captain
      area
      paymentMode
      paymentState
      paymentStatus
      paidAmt
      balanceAmt
  
      orderList{
        subOrderId
        totalPrice
        createdAt
        createdBy
        services{
          serviceId
          serviceName
          serviceRate
          pmInventory
          departmentId
          purchaseItemRef
          noDiscountItem
          costPrice
          qty
          isUrgent
          uId
          addons{
           isCustomQty
           attachedAddonCat
            serviceName
            serviceRate
             qty
           }
          attachedCat
          status
          instruction
          station
          kotId
          tax
          taxType
          inprocessAt
          cancelledAt
          preparedAt
          completedAt
          refId
          hsnCode
        }
      }
    }
  }`
//    {
    //    "id": "b148b379-a018-44e3-ae54-644bac405262:::25"
    //  }
    
  